import {NgModule} from "@angular/core";
import {OptionsBilling} from "./billing-letter/OptionsBilling";

@NgModule({
    providers: [
        OptionsBilling
    ]
})
export class EnumModule { }



// WEBPACK FOOTER //
// ./src/app/shared/enums/enum.module.ts